import sanitizeHtml from 'sanitize-html';

// Article HTML is authored by any signed-in user and rendered for anyone, so it is
// untrusted. Do NOT set `parser.decodeEntities: false`: the scheme check then runs on
// the still-encoded attribute (`&#106;avascript:` is not seen as `javascript:`), the
// serializer passes the entities through, and the browser decodes them into a live
// `javascript:` link.
export const ARTICLE_SANITIZE_OPTIONS = {
  allowedClasses: { '*': ['ql-*'] },
  allowedAttributes: {
    '*': ['data-list'],
    'a': ['href', 'target', 'rel']
  },
  // Explicit, not the library default (which also allows ftp:). The library applies it to
  // every URL-bearing attribute it knows (20 in 2.17.7, including action, formaction, data,
  // poster and background) and leaves relative URLs alone.
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  // Runs before the attribute allow-list, so an author-supplied rel is overwritten
  // (target="_blank" without it hands the opened page a window.opener handle).
  transformTags: {
    'a': sanitizeHtml.simpleTransform('a', { rel: 'noopener noreferrer' })
  },
  // Non-breaking spaces read as ordinary spaces. This must stay a TEXT filter: it is never
  // shown an attribute. Replacing them across the sanitised HTML string instead re-opens the
  // door, because the scheme check strips U+0000-0020 from an href but not U+00A0, so a
  // leading NBSP is kept as a relative URL, and the replace then turns it into a space the
  // browser trims, leaving a live `javascript:` URL.
  textFilter: (text) => text.replaceAll(String.fromCharCode(160), ' ')
};

// Never edit the string this returns.
export function sanitizeArticleContent(content) {
  return sanitizeHtml(content || '', ARTICLE_SANITIZE_OPTIONS);
}
